import React, {Component} from "react";
import {match} from "react-router";
import H from "history";
import RadialMenuContainer , {IRadialOption} from "./RadialMenuContainer";

interface IShortcutterProps {
    history: H.History;
    match: match<{tenantId: string,schoolCode: string}>;
}

interface IShortcutterState {
    showRadial: boolean;
    radialOptions?: IShortcutRadialOption[]; 
}

export interface IShortcutRadialOption extends IRadialOption
{
    keyCode: string; //alt +
    url: string;
}


export default class Shortcutter extends Component<IShortcutterProps, IShortcutterState> {
    
    constructor(props: Readonly<IShortcutterProps>) {
        super(props);
        
        this.state = {
            showRadial: false
        };
    }

    public componentDidMount() {
        this.setupOnKeyUp();
    }
    
    componentDidUpdate(prevProps: Readonly<IShortcutterProps>, prevState: Readonly<IShortcutterState>, snapshot?: any): void {
    }
    componentWillUnmount() {
        document.onkeyup = null;
    }
    
    public static radialShortcutKeyCode = "KeyA";
    
    public static nonSchoolOptions: IShortcutRadialOption[] = [
        {
            id: "All Workloads",
            title: "Workloads",
            keyCode: "KeyW",
            url: "/cdb-admin/workloads"
        },
        {
            id: "All Schools",
            title: "All Schools",
            keyCode: "KeyS",
            url: "/cdb-admin/schools"
        },
        {
            id: "Mailroom Dashboard",
            title: "Mailroom",
            keyCode: "KeyM",
            url: "/cdb-admin/mailroom"
        },
        {
            id: "All Rollovers",
            title: "Rollovers",
            keyCode: "KeyR",
            url: "/cdb-admin/rollover"
        }
    ];


    public static buildSchoolOptions(tenantId: string, schoolCode: string): IShortcutRadialOption[]
    {
        return [
            {
                id: "Workloads",
                title: "Workloads",
                keyCode: "KeyW",
                url: `/cdb-admin/schools/${tenantId}/${schoolCode}`
            },
            {
                id: "All Schools",
                title: "All Schools",
                keyCode: "KeyS",
                url: "/cdb-admin/schools"
            },
            {
                id: "Mailroom",
                title: "Mailroom",
                keyCode: "KeyM",
                url: `/cdb-admin/mailroom/${tenantId}/${schoolCode}`
            },
            {
                id: "Inbox",
                title: "Inbox",
                keyCode: "KeyI",
                url: `/cdb-admin/mailroom/salamander/${tenantId}/${schoolCode}/inbox`
            },
            {
                id: "Configure",
                title: "Configure",
                keyCode: "KeyC",
                url: `/cdb-admin/schools/${tenantId}/${schoolCode}/configure`
            },
            {
                id: "Edit",
                title: "Edit",
                keyCode: "KeyE",
                url: `/cdb-admin/schools/${tenantId}/${schoolCode}/edit`
            }
        ]
    }
    
    private setupOnKeyUp(): void
    {
        document.onkeyup = (e: KeyboardEvent) => {
            
            if(!e.altKey)
            {
                return;
            }
            
            const tenantId = this.props.match.params.tenantId;
            const schoolCode = this.props.match.params.schoolCode;
            let relevantOptions: IShortcutRadialOption[] = [];
            if(tenantId && schoolCode)
            {
                relevantOptions = Shortcutter.buildSchoolOptions(tenantId,schoolCode);
            }
            else
            {
                relevantOptions = Shortcutter.nonSchoolOptions;
            }
            
            if(e.code == Shortcutter.radialShortcutKeyCode)
            {
                this.setState({
                    showRadial: true,
                    radialOptions: relevantOptions
                });
                return;
            }
            else
            {
                for (const relevantOption of relevantOptions)
                {
                    if(e.code === relevantOption.keyCode)
                    {
                        this.props.history.push(relevantOption.url);
                    }
                }
            }

        }
    }
    
    public render() {
        
        if(!this.state.showRadial)
        {
            return null;
        }
        
        return (
            <RadialMenuContainer
                items={this.state.radialOptions!}
                onClick={(item: IShortcutRadialOption) => {
        
                    this.props.history.push(item.url);
                    this.setState({
                        showRadial: false
                    });
        
                }}
                onClose={() => {
                    this.setState({showRadial: false})
                }
            }/>
        );
    }
}